import { Tabs as TabsPrimitive } from '@base-ui/react/tabs';

import { cn } from '@/lib/utils';

export type TabsTriggerProps = TabsPrimitive.Tab.Props;

const TabsTrigger = ({ className, ...props }: TabsTriggerProps) => {
  return (
    <TabsPrimitive.Tab
      data-slot="tabs-trigger"
      className={cn(
        'relative inline-flex flex-1 cursor-pointer items-center justify-center gap-1.5 rounded-md border border-transparent text-sm font-medium whitespace-nowrap',
        'h-[calc(100%-1px)] px-2 py-0.5',
        "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        'text-gray-900/60',
        'after:absolute after:bg-white after:opacity-0 after:transition-opacity',
        'transition-all',

        'group-data-horizontal/tabs:after:inset-x-0 group-data-horizontal/tabs:after:-bottom-1.25 group-data-horizontal/tabs:after:h-1',
        'group-data-vertical/tabs:after:inset-y-0 group-data-vertical/tabs:after:-left-1 group-data-vertical/tabs:after:w-1',
        'group-data-vertical/tabs:w-full group-data-vertical/tabs:justify-start',

        'group-data-[variant=default]/tabs-list:data-active:text-white group-data-[variant=default]/tabs-list:data-active:shadow-sm group-data-[variant=default]/tabs-list:data-active:hover:text-white',
        'group-data-[variant=line]/tabs-list:text-gray-900 group-data-[variant=line]/tabs-list:data-active:bg-transparent group-data-[variant=line]/tabs-list:data-active:shadow-none group-data-[variant=line]/tabs-list:data-active:hover:bg-transparent',
        'group-data-[variant=line]/tabs-list:data-active:after:bg-green-400 group-data-[variant=line]/tabs-list:data-active:after:opacity-100',

        'hover:bg-gray-200 focus-visible:border-gray-900',
        'focus-visible:ring-[3px] focus-visible:ring-gray-900/30 focus-visible:outline-1 focus-visible:outline-gray-900/30',
        'data-active:bg-gray-900/70 data-active:hover:bg-gray-900/70',
        'disabled:cursor-not-allowed disabled:bg-transparent! disabled:text-gray-500 aria-disabled:cursor-not-allowed aria-disabled:bg-transparent! aria-disabled:text-gray-500',
        className,
      )}
      {...props}
    />
  );
};

export default TabsTrigger;
